const Required = () => '*';

export default Required;
